import { useStanQuery } from '@/queries';
import { QUERY_KEYS, SENTRY_FEATURES } from '@/lib/constants';
import { fetchRecipientsList } from '@/lib/api/email-flows';

export const useOptInRecipientCount = () => {
    return useStanQuery(
        {
            queryKey: [QUERY_KEYS.RECIPIENTS_LIST, 'opt-in-count'],
            queryFn: async () => {
                const response = await fetchRecipientsList({
                    page: 1,
                    pageSize: 10, // Use same pageSize as the main table
                    filter_array: JSON.stringify([
                        {
                            fieldName: 'receipient-status',
                            operator: 'eq',
                            value: 'require_opt_in',
                            type: 'select',
                            urlCode: 'eq',
                        },
                    ]),
                });
                // Calculate total count: (total_pages - 1) * pageSize + current page length
                // This handles the case where the last page might have fewer items
                const pageSize = 10;
                const totalCount =
                    response.total_pages > 0
                        ? (response.total_pages - 1) * pageSize + response.recipient_list.length
                        : 0;
                return totalCount;
            },
            staleTime: 1000 * 60 * 2,
            meta: {
                error: {
                    sentryMessage: '[EMAIL_FLOWS] Failed to fetch opt-in recipient count',
                    feature: SENTRY_FEATURES.EMAIL_FLOWS,
                },
            },
        },
        true
    );
};
